module.exports = __webpack_public_path__ + "static/img/contactUs.37f06640.png";